module.exports = __webpack_public_path__ + "img/test_four2.9da6ff1f.png";